import { render } from "./letter-pattern-create.vue?vue&type=template&id=c4a62c2a"
import script from "./letter-pattern-create.vue?vue&type=script&lang=js"
export * from "./letter-pattern-create.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__